/** Binary units match BigQuery's TiB-based reference pricing. */
export function formatScanBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB'];
  const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** power).toLocaleString('en-US', { maximumFractionDigits: 2 })} ${units[power]}`;
}

export function formatScanUsd(usd: number): string {
  if (usd === 0) return 'US$0.00';
  if (usd < 0.01) return '< US$0.01';
  return `~US$${usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
